<template>
  <filter-summary
    icon="option"
    title="棚割パターン"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ items.length }}パターン</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 売場分析の「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    items: {
      type: Array,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
